import script from "./AdministratorShowcaseDenyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorShowcaseDenyForm.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorShowcaseDenyForm.vue?vue&type=style&index=0&id=06c81817&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c81817"]])

export default __exports__